export default "__VITE_ASSET__86776824__"